<template>
  <md-card class="m-0">
    <md-card-header>Source &amp; Uses of Funds</md-card-header>
    <md-card-content>
      <div class="md-layout sources-users-content">
        <div class="md-layout-item md-medium-size-100 md-size-100 p-0 border-0">
          <md-table v-model="changein" table-header-color="blue" class="sources-users-table">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Change In:">
                {{
                  item.title
                }}
              </md-table-cell>

              <md-table-cell md-label="Trend" class="table_chart">
                <chart-card
                  v-if="newChartChangeinOptions && newChartChangeinOptions[item.name]"
                  header-animation="false"
                  :chart-data="newChartChangeinOptions[item.name].data"
                  :chart-options="chartOptions"
                  chart-type="Line"
                  header-icon
                  chart-inside-content
                  no-footer
                  background-color="blue"
                ></chart-card>
              </md-table-cell>

              <md-table-cell
                v-for="key in Object.keys(item.dates)"
                :key="key + 'change'"
                :md-label="(key === '19-' ? '19-20' : (key === '-21' ? '20-21' : key))"
              >{{ numberWithCommas(item.dates[key]) }}</md-table-cell>
            </md-table-row>
          </md-table>
          <div class="md-layout px-4">
            <p><b>Sources and Uses:</b> The Sources and Uses of Funds table tests the accuracy of the balance sheet and distinguishes the sources of funds from their use. It is the basic worksheet preliminary to a formal cash flow statement examining the liquidity of a business. A multi-year industry benchmark common size balance sheet, which includes overlapped but not identical sets of firms in each year, is not well-suited for the presentation of a formal cash flow analysis.</p>
          </div>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import { ChartCard } from '@/components';
import { mapState } from 'vuex';
import formatData from "@/mixins/format-data";
import IFReportHeader from './_partials/IFHeader.vue';

export default {
  components: {
    ChartCard,
    // IFReportHeader,
  },
  mixins: [formatData],
  data() {
    return {
      changein: [],
      worksheet: [],
      newChartChangeinOptions: [],
      newChartWorksheetOptions: [],
      display_source_uses: false,
      chartOptions: {
        lineSmooth: this.$Chartist.Interpolation.cardinal({
          tension: 1,
        }),
        chartPadding: {
          top: 5,
          right: 5,
          bottom: 5,
          left: 5
        },
        axisY: {
          showGrid: false,
          showLabel: false,
          offset: 0,
        },
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0,
          scaleMinSpace: 6
        },
        showPoint: true,
        showLabel: false,
        width: "100px",
        height: "25px",
        seriesBarDistance: 10,
        fullWidth: true,
      },
    };
  },
  watch: {
    report(newVal, oldVal) {
        this.init();
    },
  },
  computed: {
    ...mapState({
      data: (state) => state.user.report.data,
      sourcesUses: (state) => state.user.report['sourcesUses'],
      years: (state) => state.user.report['sourcesUses']['years'],
      showYears: (state) => state.user.report.showYears,
      report: (state) => state.user.report,
    }),
    tablesInfo() {
      return _.omit(this.sourcesUses, 'years');
    },
    filteredData() {
      return Object.values(this.data).filter((item) => item);
    },
    actualData() {
      return this.filteredData[0]['cashflow'];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    formatData(table, data) {
      let getDates = (id) =>
        this.years.reduce((acc, cur, index) => {
          let value = this.actualData[this.years.length - index - 1][id];

          value = isNaN(Number(value)) ? value : Number(value.toFixed(0));

          return { ...acc, [cur]: value };
        }, {});

      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },
    init() {
      if (this.report.displaySettings.includes('source_uses')) {
        this.display_source_uses = true;
      }
      Object.entries(this.tablesInfo).forEach(([table, data]) =>
        this.$set(this, table, this.formatData(table, data))
      );
      let filtered_years = [];
      this.showYears.forEach((s, i) => {
        if (s) {
          filtered_years.push(this.years[i]);
        }
      });
      if (!filtered_years.length) {
        filtered_years = this.years;
      }

      this.changein = this.changein.concat(this.worksheet);

      this.changein = this.changein.map((item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return !filtered_years.includes(fItem);
        });
        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      });

      this.changein.forEach(async function(element, index) {
        if (element.dates && element.dates['19-']) {
          // let newVal1 = element.dates['19-'];
          element.dates['19-20'] = await element.dates['19-'];
          await delete element.dates['19-'];
        }
        if (element.dates && element.dates['-21']) {
          element.dates['20-21'] = await element.dates['-21'];
          await delete element.dates['-21'];
        }
      });

      this.changein.forEach((element, index) => {
        this.newChartChangeinOptions[element.name] = {
          data: {
            labels: [[...Object.keys(element.dates).map(i => parseFloat(element.dates[i]))]],
            series: [[...Object.keys(element.dates).map(i => parseFloat(element.dates[i]))]]
          },
        }
      });

      this.worksheet = this.worksheet.map((item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return !filtered_years.includes(fItem);
        });
        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      });
      this.worksheet.forEach(element => {
        this.newChartWorksheetOptions[element.name] = {
          data: {
            labels: [[...Object.keys(element.dates).map(i => parseFloat(element.dates[i]))]],
            series: [[...Object.keys(element.dates).map(i => parseFloat(element.dates[i]))]]
          },
        }
      });
    }
  },
};
</script>
<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}
.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}
.md-card-content .sources-users-content {
    background-color: #ffffff;
}
</style>
